export default {
  svgPath: `
  <path fill-rule="evenodd" clip-rule="evenodd" d="M16.5 10.086l-5.5 5.5V1H9v14.586l-5.5-5.5L2.086 11.5l7.207 7.207a1 1 0 001.414 0l7.207-7.207-1.414-1.414z"/>
  `,
  title: 'Arrow Down',
  viewBox: '0 0 20 20',
};
